export default __webpack_public_path__ + "static/assets/auth-page.365c3faacd1f165042698266a52bf256.png";